import { object } from '@iwentsourcing/core/typing/object.js';
import { string } from '@iwentsourcing/core/typing/string.js';
import { StreamArgs } from './stream-args.js';
import { optional } from '@iwentsourcing/core/typing/optional.js';
import { date } from '@iwentsourcing/core/typing/date.js';

export const GetEvent = object('GetEvent', {
  realm: string(),
  tenant: string(),
  version: string(),
  pattern: string(),
  id: string(),
  args: StreamArgs,

  token: optional(string()),
});

export const AwaitProcessState = object('AwaitProcessState', {
  realm: string(),
  tenant: string(),
  version: string(),
  pattern: string(),
  args: StreamArgs,

  eventId: string(),

  token: optional(string()),
});

export const IterateEvent = object('IterateEvent', {
  realm: string(),
  tenant: string(),
  version: string(),
  pattern: string(),
  args: StreamArgs,

  date: optional(date()),

  token: optional(string()),
});
